import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useSessionStorage, watchOnce } from '@vueuse/core';
// eslint-disable-next-line import/no-cycle
import { useApplicationStore } from './application-store';

export const useAuth = defineStore('auth', () => {
    const loggedInUser = ref(null);

    function setUser(user) {
        loggedInUser.value = user;
    }

    function removeUser() {
        loggedInUser.value = null;
    }

    const uuid = computed(() => loggedInUser.value?.uuid);
    const email = computed(() => loggedInUser.value?.email);
    const isLoggedIn = computed(() => Boolean(loggedInUser.value?.uuid));

    const wasLoggedIn = useSessionStorage('lokarb:auth:was-logged-in', false);

    // First time we get info whether user is logged in, perform some security measures for privacy
    watchOnce(loggedInUser, () => {
        if (!isLoggedIn.value && wasLoggedIn.value) {
            const application = useApplicationStore();
            application.$reset();
        }

        wasLoggedIn.value = isLoggedIn.value;
    });

    return {
        wasLoggedIn,
        loggedInUser,
        setUser,
        removeUser,
        uuid,
        email,
        isLoggedIn,
    };
});
